export const PAGES = 'pages'
export const FORWARDERS = 'forwarders'
export const FORWARDERS_FULL_PATH = `/${PAGES}/${FORWARDERS}`